import React, { ReactElement } from "react";
import MainBanner from "@components/businesscopymachines/mainBanner/mainBanner";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import BusinessCopyMachinesWrapper from "@components/layouts/businessCopyMachines";

const Benefits = dynamic(
    () => import("@components/businesscopymachines/benefits"),
);
const OffersList = dynamic(() => import("@components/shared/offersList"));
const WhatToLook = dynamic(
    () => import("@components/businesscopymachines/whatToLook"),
);

export default function BusinessCopyMachinesHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <BusinessCopyMachinesWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <Benefits />
            <WhatToLook />
        </BusinessCopyMachinesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
